module.exports = __webpack_public_path__ + "img/lobby4.2cfc443c.jpg";